import type { FaireProductEntity } from "../../entity_types/product";

export const p_ksnfarka6p: FaireProductEntity = {
  token: "p_ksnfarka6p",
  type: "product",
  name: "Children's Elderberry Respiratory Support Tincture",
  brandToken: "b_94g7ixtg9k",
  brandName: "Birth Song Botanicals Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/eae97625b417d966fa34ab3684cf5ebd4f257997c04f310bfb175753b4cea2f9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/81fbefbfa683a7c8cb0abecdc58fc70e9999715670a68411601f01cb2fbc76b2.jpeg",
    "https://cdn.faire.com/fastly/3262795adadca98cc1629a151719d78ce20a0914b7930b90f3ab40b86ad8d790.jpeg",
    "https://cdn.faire.com/fastly/666ac0fdf0476e7bd87b3992503a16aab4356849fc9394e0099f66b8104acd18.jpeg",
    "https://cdn.faire.com/fastly/cc30a319d7a05d7a3bda94ef86db0ac02e1aba0062c275feb77c58985964bbdb.jpeg",
  ],
  priceDollars: 11.73,
  description:
    "\n\n\n\nChildren’s Respiratory Support Herbal Tincture\n\nEnsure your child breathes easy with our Children’s Respiratory Support Herbal Tincture, a natural remedy expertly formulated to soothe coughs, ease colds, and relieve congestion. Perfectly paired with our Children’s Healing Herbal Bath, this tincture provides comprehensive respiratory support, promoting comfort and well-being.\n\nOur Children’s Respiratory Support Tincture is designed with a sweet, pleasant taste that kids love, making it easy to administer. Ideal for children 6 months and older, this tincture offers gentle, effective relief when your little one needs it most.\n\n\n\nKey Benefits:\n\n * Relieves Coughs and Congestion: Combines the power of Organic Elderberry Fruit, Organic Wild Cherry Bark, and Organic Thyme Leaf to help alleviate coughs and clear nasal passages.",
  tags: [],
  msrpDollars: 19.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:02.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
